import React from 'react';
import Button from 'material-ui/Button';

import { observer, inject } from 'mobx-react';

const StateButton = ({ document, document_store, history, onDone }) => {

    if (document_store.finishing || document_store.activating) {
        return (<Button disabled={true}>Aguarde...</Button>);
    }

    const finishDocument = async e => {
        if (window.confirm('Deseja realmente finalizar esse Documento de Entrega?')) {
            const response = await document_store.finish(document);

            if (response.status !== 200) {
                alert('Falha ao finalizar o Documento de Entrega.');
            } else {
                onDone();
            }
        }
    }

    const activeDocument = async e => {
        if (window.confirm('Deseja realmente ativar esse Documento de Entrega?')) {
            const result = await document_store.active(document);

            if (result.status !== 200) {
                const status = result.response.status;

                if (status === 409) {
                    alert('Já existe um Documento de Entrega ativado para este veículo. Por favor, finalize o documento anterior para ativar um novo.');
                } else {
                    alert('Falha ao ativar o Documento de Entrega.');
                }
            }
        }
    }

    const onClick = e => {
        switch(document.status) {
            case 'pending':
                activeDocument(e);
                break;

            case 'active':
                finishDocument(e);
                break;

            default:
                break;
        }
    }

    let label;

    switch(document.status) {
        case 'pending':
            label = "Ativar";
            break;

        case 'active':
            label = "Finalizar";
            break;

        default:
            break;
    }

    return (
        <Button onClick={onClick} disabled={!!!label} data-updated-at={document_store.updated_at}>
            {label || 'Finalizado'}
        </Button>
    );

}

let container = observer(StateButton);
container = inject(['document_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/components/StateButton.js